import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Montserrat } from 'v3/styles/common';

export const SubtitleLargeStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 1.125rem ${Montserrat}`,
}));
export const SubtitleLargeBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `500 1.125rem ${Montserrat}`,
}));
